import { IdataBinding } from "@ispm-client/modules/aggregator/interfaces";
import { AgregationService } from "@ispm-client/modules/aggregator/services";
import { isEmpty } from "lodash";
import { forkJoin, Observable, of } from "rxjs";
import { map, take, tap } from "rxjs/operators";

export type functionMapper = {[key: string]: (...args: any) => Observable<boolean>};

export interface IClinicalInfoFormAttributes{
    hideOn: IClinicalInfoFormAttributesCondition;
}

export interface IClinicalInfoFormAttributesCondition {
    and?: IClinicalInfoFormAttributesCondition[];
    or?: IClinicalInfoFormAttributesCondition[];
    isEmptyValue?: string[];
}

export class ClinicalInfoForm {
    constructor(public formId: string, public formName: string, public attributes: IClinicalInfoFormAttributes = null, public queryAgregator: AgregationService){}

    conditionMapper: functionMapper = {
        emptyQueryResults: this.checkEmptyQueryResults.bind(this)
    }

     needToHideForm(): Observable<boolean> {
        if (this.attributes && this.attributes.hideOn) {
            return  this.checkHideOnCondition();
        }
        return of(false);
    }

    checkCondition(condition: IClinicalInfoFormAttributesCondition, data?: any): Observable<boolean> {
        if (condition.and) {
            return this.checkAndConditions(condition.and);
        }
        if (condition.or) {
            return this.checkOrConditions(condition.or);
        }
        const conditionToCheck = Object.keys(condition)[0];
        return this.conditionMapper[conditionToCheck](condition[conditionToCheck], data).pipe(take(1));
    }

    checkHideOnCondition(): Observable<boolean> {
        return this.checkCondition(this.attributes.hideOn);
    }

     checkAndConditions(conditions: IClinicalInfoFormAttributesCondition[]): Observable<boolean> {
        return forkJoin(conditions.map(condition => this.checkCondition(condition))).pipe(
            map(results => results.every(result => result))
        )
    }

     checkOrConditions(conditions: IClinicalInfoFormAttributesCondition[]): Observable<boolean> {
        return forkJoin(conditions.map(condition => this.checkCondition(condition))).pipe(
            map(results => results.some(result => result))
        )
    }

     checkEmptyQueryResults(queriesToCheck: Array<IdataBinding>): Observable<boolean> {
         console.log("calling checkEmptyQueryResults");
            return this.queryAgregator.registerQuery(queriesToCheck).pipe(
                take(1),
                map(responses => responses.every(response => isEmpty(Object.values(response)[0])))
            )
    }
}

